import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { Action_order_list } from '../../../store/action/action-order';
import LoadingHook from '../../hooks/LoadingHook'
import { Typography } from '@material-ui/core';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { utils } from '../../../utils';
import useTableStyles from '../../../assets/css/materialUI/tableCss'
import dateFormat from 'dateformat';
import CachedIcon from '@material-ui/icons/Cached';


function Row({ order }) {

    const classes = useTableStyles();
    const [open, setOpen] = React.useState(false);
    const baseImgUrl = utils.constants.S3_imgBaseURL;


    return (
        <React.Fragment>

            <TableRow className={[classes.tr, classes.root]}>

                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>


                <TableCell component="th" scope="row">
                    {/* {order.createdAt} */}
                    {dateFormat(order.createdAt)}
                </TableCell>
                <TableCell align="right">{utils.formateCurrency(order.totalPrice)}</TableCell>
                <TableCell align="right">{order.isPaid}</TableCell>
                <TableCell align="right">{order.isDelivered}</TableCell>
                <TableCell align="right">
                    {order.shippingAddress.address} &nbsp;
                    {order.shippingAddress.email} &nbsp;
                </TableCell>
            </TableRow>


            <TableRow className={classes.tr}>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" color="textSecondary" gutterBottom component="h6">
                                Order Items
                            </Typography>

                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Image</TableCell>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Total price ($)</TableCell>
                                        <TableCell align="right">sellerID</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {order.orderItems.map((item) => (
                                        <TableRow hover="true" key={item.productID} className={classes.tr}>
                                            <TableCell><img
                                                alt={item.name}
                                                src={baseImgUrl + item.seller + '/' + item.image}
                                                className={classes.prodImg} />
                                            </TableCell>
                                            <TableCell component="th" scope="row">{item.productID}</TableCell>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>{item.qty}</TableCell>
                                            <TableCell >{item.price} </TableCell>
                                            <TableCell align="right">{item.seller} </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

Row.propTypes = {
    order: PropTypes.shape({
        createdAt: PropTypes.date,
        totalPrice: PropTypes.number,
        isPaid: PropTypes.bool,
        isDelivered: PropTypes.bool,
        shippingAddress: PropTypes.object.isRequired,
        price: PropTypes.number.isRequired,
        orderItems: PropTypes.arrayOf(
            PropTypes.shape({
                qty: PropTypes.number.isRequired,
                productID: PropTypes.string.isRequired,
                price: PropTypes.number,
            }),
        ).isRequired,
    }).isRequired,
}


export default function UserOrdersScreen() {
    const dispatch = useDispatch()
    const classes = useTableStyles();
    const { orders, loading } = useSelector(state => state.reducer_order)
    const { user } = useSelector(state => state.reducer_user)

    useEffect(() => {
        if (!orders) {
            dispatch(Action_order_list())
        }
    }, [])


    return (
        <div>
            {/* <Paper className={classes.ppr}> */}

            {loading && <LoadingHook />}

            {orders &&
                <TableContainer component={Paper} className={classes.ppr} >
                    <Typography component="h1" gutterBottom className={classes.tblTitle} >
                        Orders History: {user.name}

                        <IconButton aria-label="refresh"
                            style={{ float: 'right' }}
                            size='medium'
                            onClick={() => dispatch(Action_order_list())}
                        >
                            <CachedIcon />
                        </IconButton>

                    </Typography>

                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell align="right">Price</TableCell>
                                <TableCell align="right">Paid</TableCell>
                                <TableCell align="right">Delivered</TableCell>
                                <TableCell align="right">Shipping Address</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orders.map((order) => (
                                <Row key={order._id} order={order} />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}

        </div>
    )
}
